<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link } from "svelte-routing";
	import PageHeader from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Documentação Necessária';    
</script>

<section class="conteudo-internas">
	<PageHeader title={titlePage}></PageHeader>    
	<div class="container">
		<p>Confira as documentações solicitadas para locação:</p>
		<div class="box-itens-icon mb-20">
			<div class="item">
				<div class="icon">
					<i class="fas fa-user"></i>
				</div>
				<div class="infos">
					<h2 class="title text-uppercase color-primary">Locatário Pessoa Física</h2>
					<ul class="list-cycle">
						<li>Carteira de Identidade</li>
						<li>CPF</li>
						<li>Comprovante de renda (três vezes o valor do aluguel e encargos)</li>
						<li>Carteira profissional atualizada<br>(folha dos dados pessoais, último contrato e última alteração salarial)</li>
						<li>Declaração de imposto de renda (última apresentada a Receita Federal)</li>
						<li>Comprovante de residência</li>
						<li>Certidões negativas dos cartórios de protestos de títulos</li>
						<li>Carteira de identidade e CPF do cônjuge ou companheiro(a)</li> 
					</ul>
					<a class="btn btn-primary icon-transform mt-20" href="/fichas-cadastrais" use:link title="Clique aqui para fazer o download da ficha cadastral">
						Download Ficha Cadastral  <i class="fas fa-download ml-10"></i> 
					</a>
				</div>
			</div>
			<div class="item">
				<div class="icon hidden-xl hidden-lg hidden-md">
					<i class="fas fa-user-tie"></i>
				</div>
				<div class="infos">
					<h2 class="title text-uppercase color-primary">Locatário Pessoa Jurídica</h2>
					<ul class="list-cycle">
						<li>Contrato social e última alteração registrada no órgão competente</li>
						<li>Ficha do CNPJ emitida no site da Receita Federal</li>
						<li>Último balancete e balanço patrimonial</li>
						<li>Última declaração do Imposto de Renda</li>
						<li>Comprovante de pagamento do IRPJ, PIS, COFINS, CSLL <br />(últimos três meses)</li>
						<li>Carteira de identidade e CPF dos Sócios</li>
					</ul>
					<a class="btn btn-primary icon-transform mt-20" href="/fichas-cadastrais" use:link title="Clique aqui para fazer o download da ficha cadastral">
						Download Ficha Cadastral  <i class="fas fa-download ml-10"></i> 
					</a>
				</div>
				<div class="icon hidden-sm hidden-xs">
					<i class="fas fa-user-tie"></i>
				</div>
			</div>
			<div class="item">
				<div class="icon">
					<i class="fas fa-user"></i>
				</div>
				<div class="infos">
					<h2 class="title text-uppercase color-primary">Fiador Pessoa Física</h2>
					<ul class="list-cycle">
						<li>Carteira de identidade</li>
						<li>CPF</li>
						<li>Comprovante de renda (três vezes o valor do aluguel e encargos)</li>
						<li>Carteira profissional atualizada<br>
						(folha dos dados pessoais, último contrato e última alteração salarial)</li>
						<li>Declaração de imposto de renda (última apresentada a Receita Federal)</li>
						<li>Comprovante de residência</li>
						<li>Certidões negativas dos cartórios de protestos de títulos</li>
						<li>Carteira de identidade e CPF do cônjuge ou companheiro(a)</li>
						<li>Matricula atualizada de dois imóveis localizados em Porto Alegre ou <br>grande Porto Alegre, acompanhada de certidão negativa de ônus <br>e de ação real e pessoal reipersecutória.</li>
						<a class="btn btn-primary icon-transform mt-20" href="/fichas-cadastrais" use:link title="Clique aqui para fazer o download da ficha cadastral">
							Download Ficha Cadastral  <i class="fas fa-download ml-10"></i> 
						</a>
					</ul>
				</div>
			</div>
			<div class="item">
				<div class="icon hidden-xl hidden-lg hidden-md">
					<i class="fas fa-user-tie"></i>
				</div>
				<div class="infos">
					<h2 class="title text-uppercase color-primary">Fiador Pessoa Jurídica</h2>
					<ul class="list-cycle">
						<li>Contrato social e última alteração registrada no órgão competente</li>
						<li>Ficha do CNPJ emitida no site da Receita Federal</li>
						<li>Último balancete e balanço patrimonial</li>
						<li>Última declaração do Imposto de Renda</li>
						<li>Comprovante de pagamento do IRPJ, PIS, COFINS, CSLL (últimos três meses)</li>
						<li>Carteira de identidade e CPF dos Sócios</li>
						<li>Matricula atualizada de dois imóveis localizados em Porto Alegre ou grande Porto Alegre, acompanhada de certidão negativa de ônus e de ação real e pessoal reipersecutória.</li>
					</ul>
					<a class="btn btn-primary icon-transform mt-20" href="/fichas-cadastrais" use:link title="Clique aqui para fazer o download da ficha cadastral">
						Download Ficha Cadastral  <i class="fas fa-download ml-10"></i> 
					</a>
				</div>
				<div class="icon hidden-sm hidden-xs">
					<i class="fas fa-user-tie"></i>
				</div>
			</div>
			<div class="item">
				<div class="icon">
					<i class="fas fa-user-shield"></i>
				</div>
				<div class="infos">
					<h2 class="title text-uppercase color-primary">Locador</h2>
					<ul class="list-cycle">
						<li>Encaminhar cópia dos seguintes documentos:</li>
						<li>Carteira de Identidade</li>
						<li>CPF</li>
						<li>Matrícula do imóvel que será colocado para administração</li>
						<li>Cópia do último condomínio pago</li>
						<li>Cópia do pagamento de IPTU do ano corrente</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</section>